/** Editable copy for UGC wizard host-subscription upsell (Step 2 — Budget & Targeting). */
export const UGC_CAMPAIGN_HOST_SUBSCRIBE_UPSELL_COPY = {
    /**
     * Placeholders:
     * - `{{currentRate}}` — formatted unsubscribed min payout per creator (e.g. "$15")
     * - `{{extraCreators}}` — additional creator slots at subscribed min payout (same budget)
     * - `{{subscribedRate}}` — formatted subscribed min payout per creator (e.g. "$7")
     */
    currentRateLineTemplate: 'Currently you will pay a minimum of {{currentRate}}/creator.',
    bannerMessageTemplate:
        'This campaign could get you {{extraCreators}} more creators at {{subscribedRate}}/creator with a host subscription.',
    subscribeButtonLabel: 'View host plans',
} as const;

function applyUpsellPlaceholders(
    template: string,
    values: { currentRate: string; extraCreators: number; subscribedRate: string },
): string {
    return template
        .replace('{{currentRate}}', values.currentRate)
        .replace('{{extraCreators}}', String(values.extraCreators))
        .replace('{{subscribedRate}}', values.subscribedRate);
}

export function formatUgcHostSubscribeUpsellCurrentRateLine(currentRateFormatted: string): string {
    return applyUpsellPlaceholders(UGC_CAMPAIGN_HOST_SUBSCRIBE_UPSELL_COPY.currentRateLineTemplate, {
        currentRate: currentRateFormatted,
        extraCreators: 0,
        subscribedRate: '',
    });
}

export function formatUgcHostSubscribeUpsellMessage(extraCreators: number, subscribedRateFormatted: string): string {
    return applyUpsellPlaceholders(UGC_CAMPAIGN_HOST_SUBSCRIBE_UPSELL_COPY.bannerMessageTemplate, {
        currentRate: '',
        extraCreators,
        subscribedRate: subscribedRateFormatted,
    });
}
